import React from "react";
import {
  Gift, Heart, Briefcase, Flower2, Ribbon, Gem, Candy, Smile,
  FileText, Sparkles, Home, Leaf, Star, Baby, Cake, Music,
  Gamepad2, BookOpen, Watch, Camera, Shirt, Coffee, Wine,
  Palette, Globe, Trophy, Flame, Package, ShoppingBag,
} from "lucide-react";

export interface CategoryItem {
  id: number;
  name: string;
  parentId?: number | null;
  color?: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
   image?: any;
}

/* ======================================================
   🎁 GIFTS & OCCASIONS DOMAIN (1520xxxxx)
   Everything gifted for any occasion — birthdays,
   anniversaries, weddings, baby showers, graduations,
   holidays, corporate, luxury, flowers, hampers & more
   ====================================================== */

export const giftsCategories: CategoryItem[] = [
  { id: 152000001, name: "Birthday Gifts",             color: "#FF6A00", icon: Cake },
  { id: 152000002, name: "Anniversary & Romance",      color: "#E91E63", icon: Heart },
  { id: 152000003, name: "Wedding Gifts",              color: "#F8BBD9", icon: Ribbon },
  { id: 152000004, name: "Baby Shower & Newborn",      color: "#80DEEA", icon: Baby },
  { id: 152000005, name: "Graduation & Achievement",   color: "#3F51B5", icon: Trophy },
  { id: 152000006, name: "Corporate & Business Gifts", color: "#455A64", icon: Briefcase },
  { id: 152000007, name: "Flowers & Bouquets",         color: "#8BC34A", icon: Flower2 },
  { id: 152000008, name: "Luxury & Premium Gifts",     color: "#C9A84C", icon: Gem },
  { id: 152000009, name: "Chocolates & Sweet Hampers", color: "#795548", icon: Candy },
  { id: 152000010, name: "Toys, Games & Kids",         color: "#FFC107", icon: Gamepad2 },
  { id: 152000011, name: "Books & Stationery",         color: "#607D8B", icon: BookOpen },
  { id: 152000012, name: "Festive & Holiday Gifts",    color: "#F44336", icon: Sparkles },
  { id: 152000013, name: "Home & Living Gifts",        color: "#4CAF50", icon: Home },
  { id: 152000014, name: "Wellness & Spa Gifts",       color: "#03A9F4", icon: Leaf },
  { id: 152000015, name: "Fashion & Accessories",      color: "#9C27B0", icon: Shirt },
  { id: 152000016, name: "Tech & Gadget Gifts",        color: "#212121", icon: Camera },
  { id: 152000017, name: "Food & Drink Hampers",       color: "#FF8F00", icon: ShoppingBag },
  { id: 152000018, name: "Personalized & Custom",      color: "#E91E63", icon: Palette },
  { id: 152000019, name: "Music & Entertainment",      color: "#1565C0", icon: Music },
  { id: 152000020, name: "Experiences & Vouchers",     color: "#00838F", icon: Star },
  { id: 152000021, name: "Cards & Gift Wrap",          color: "#9E9E9E", icon: FileText },
  { id: 152000022, name: "Cultural & Religious Gifts", color: "#6A1B9A", icon: Globe },
];

export const giftsSubcategories: CategoryItem[] = [
  /* Birthday */
  { id: 152000101, parentId: 152000001, name: "Birthday Balloons & Decorations", icon: Sparkles },
  { id: 152000102, parentId: 152000001, name: "Birthday Cakes & Treats",         icon: Cake },
  { id: 152000103, parentId: 152000001, name: "Birthday Hampers",                icon: ShoppingBag },
  { id: 152000104, parentId: 152000001, name: "Milestone Birthday (18, 21, 30, 50)", icon: Trophy },
  { id: 152000105, parentId: 152000001, name: "Kids Birthday Gifts",             icon: Smile },

  /* Anniversary */
  { id: 152000201, parentId: 152000002, name: "Roses & Romantic Bouquets",       icon: Flower2 },
  { id: 152000202, parentId: 152000002, name: "Couples Experiences",             icon: Heart },
  { id: 152000203, parentId: 152000002, name: "Jewellery & Keepsakes",           icon: Gem },
  { id: 152000204, parentId: 152000002, name: "Personalised Couple Gifts",       icon: Ribbon },
  { id: 152000205, parentId: 152000002, name: "Wine & Champagne Gifts",          icon: Wine },

  /* Wedding */
  { id: 152000301, parentId: 152000003, name: "Wedding Registry Gifts",          icon: Gift },
  { id: 152000302, parentId: 152000003, name: "Honeymoon Fund Vouchers",         icon: Star },
  { id: 152000303, parentId: 152000003, name: "Bridesmaids & Groomsmen Gifts",   icon: Ribbon },
  { id: 152000304, parentId: 152000003, name: "Table Centerpieces & Décor",      icon: Flower2 },
  { id: 152000305, parentId: 152000003, name: "Luxury Homeware Sets",            icon: Home },

  /* Baby */
  { id: 152000401, parentId: 152000004, name: "Baby Clothing & Knitwear",        icon: Baby },
  { id: 152000402, parentId: 152000004, name: "Nursery Décor & Soft Toys",       icon: Smile },
  { id: 152000403, parentId: 152000004, name: "Baby Care & Grooming Sets",       icon: Baby },
  { id: 152000404, parentId: 152000004, name: "Personalised Baby Keepsakes",     icon: Ribbon },
  { id: 152000405, parentId: 152000004, name: "Baby Hampers",                    icon: ShoppingBag },

  /* Graduation */
  { id: 152000501, parentId: 152000005, name: "Graduation Frames & Plaques",     icon: Trophy },
  { id: 152000502, parentId: 152000005, name: "Career Starter Gifts",            icon: Briefcase },
  { id: 152000503, parentId: 152000005, name: "Watches & Jewellery",             icon: Watch },
  { id: 152000504, parentId: 152000005, name: "Luggage & Travel Gifts",          icon: Globe },

  /* Corporate */
  { id: 152000601, parentId: 152000006, name: "Branded Merchandise",             icon: Briefcase },
  { id: 152000602, parentId: 152000006, name: "Executive Desk Accessories",      icon: Briefcase },
  { id: 152000603, parentId: 152000006, name: "Corporate Food & Wine Hampers",   icon: ShoppingBag },
  { id: 152000604, parentId: 152000006, name: "Award Trophies & Plaques",        icon: Trophy },
  { id: 152000605, parentId: 152000006, name: "Premium Stationery Sets",         icon: FileText },
  { id: 152000606, parentId: 152000006, name: "Tech Gifts (Power Banks, USB)",   icon: Camera },

  /* Flowers */
  { id: 152000701, parentId: 152000007, name: "Red Rose Bouquets",               icon: Flower2 },
  { id: 152000702, parentId: 152000007, name: "Mixed Seasonal Flowers",          icon: Flower2 },
  { id: 152000703, parentId: 152000007, name: "Dried & Preserved Flowers",       icon: Flower2 },
  { id: 152000704, parentId: 152000007, name: "Potted Plants & Succulents",      icon: Leaf },
  { id: 152000705, parentId: 152000007, name: "Floral Arrangements (Same-day)",  icon: Flower2 },
  { id: 152000706, parentId: 152000007, name: "Flower & Chocolate Combos",       icon: Gift },

  /* Luxury */
  { id: 152000801, parentId: 152000008, name: "Designer Fragrance & Perfume",    icon: Gem },
  { id: 152000802, parentId: 152000008, name: "Luxury Watches",                  icon: Watch },
  { id: 152000803, parentId: 152000008, name: "Fine Jewellery",                  icon: Gem },
  { id: 152000804, parentId: 152000008, name: "Premium Leather Goods",           icon: Briefcase },
  { id: 152000805, parentId: 152000008, name: "Luxury Hampers & Boxes",          icon: ShoppingBag },
  { id: 152000806, parentId: 152000008, name: "Crystal & Glassware",             icon: Gem },

  /* Chocolates & Sweets */
  { id: 152000901, parentId: 152000009, name: "Belgian & Dark Chocolate",        icon: Candy },
  { id: 152000902, parentId: 152000009, name: "Truffle Boxes",                   icon: Candy },
  { id: 152000903, parentId: 152000009, name: "Candy & Sweet Hampers",           icon: Candy },
  { id: 152000904, parentId: 152000009, name: "Chocolate Fondue Sets",           icon: Candy },
  { id: 152000905, parentId: 152000009, name: "Macarons & Patisseries",          icon: Candy },

  /* Toys & Kids */
  { id: 152001001, parentId: 152000010, name: "Building Blocks & LEGO",          icon: Gamepad2 },
  { id: 152001002, parentId: 152000010, name: "Soft Toys & Plushies",            icon: Smile },
  { id: 152001003, parentId: 152000010, name: "Board Games & Puzzles",           icon: Gamepad2 },
  { id: 152001004, parentId: 152000010, name: "Remote Control Toys",             icon: Gamepad2 },
  { id: 152001005, parentId: 152000010, name: "Arts & Crafts Kits",              icon: Palette },
  { id: 152001006, parentId: 152000010, name: "Educational Toys",                icon: BookOpen },

  /* Books & Stationery */
  { id: 152001101, parentId: 152000011, name: "Bestseller Books",                icon: BookOpen },
  { id: 152001102, parentId: 152000011, name: "Children's Books",                icon: BookOpen },
  { id: 152001103, parentId: 152000011, name: "Journals & Notebooks",            icon: FileText },
  { id: 152001104, parentId: 152000011, name: "Luxury Pens & Writing Sets",      icon: FileText },
  { id: 152001105, parentId: 152000011, name: "Art & Stationery Sets",           icon: Palette },

  /* Festive */
  { id: 152001201, parentId: 152000012, name: "Christmas Gifts & Stockings",     icon: Sparkles },
  { id: 152001202, parentId: 152000012, name: "Eid & Ramadan Gifts",             icon: Sparkles },
  { id: 152001203, parentId: 152000012, name: "Diwali Gift Sets",                icon: Flame },
  { id: 152001204, parentId: 152000012, name: "Valentine's Day",                 icon: Heart },
  { id: 152001205, parentId: 152000012, name: "Mother's Day Gifts",              icon: Flower2 },
  { id: 152001206, parentId: 152000012, name: "Father's Day Gifts",              icon: Trophy },
  { id: 152001207, parentId: 152000012, name: "New Year & Celebration Gifts",    icon: Sparkles },
  { id: 152001208, parentId: 152000012, name: "Easter & Spring Gifts",           icon: Flower2 },

  /* Home & Living */
  { id: 152001301, parentId: 152000013, name: "Candles & Diffusers",             icon: Flame },
  { id: 152001302, parentId: 152000013, name: "Picture Frames & Wall Art",       icon: Palette },
  { id: 152001303, parentId: 152000013, name: "Kitchenware & Cookware",          icon: Coffee },
  { id: 152001304, parentId: 152000013, name: "Cushions & Throws",               icon: Home },
  { id: 152001305, parentId: 152000013, name: "Table Linen & Napkins",           icon: Home },
  { id: 152001306, parentId: 152000013, name: "Indoor Plants & Pots",            icon: Leaf },

  /* Wellness */
  { id: 152001401, parentId: 152000014, name: "Spa & Pamper Gift Sets",          icon: Leaf },
  { id: 152001402, parentId: 152000014, name: "Essential Oils & Diffusers",      icon: Flame },
  { id: 152001403, parentId: 152000014, name: "Bath Bombs & Salts",              icon: Leaf },
  { id: 152001404, parentId: 152000014, name: "Skincare & Beauty Hampers",       icon: Gem },
  { id: 152001405, parentId: 152000014, name: "Yoga & Meditation Kits",          icon: Star },
  { id: 152001406, parentId: 152000014, name: "Health Supplements Gift Box",     icon: Leaf },

  /* Fashion */
  { id: 152001501, parentId: 152000015, name: "Scarves & Wraps",                 icon: Shirt },
  { id: 152001502, parentId: 152000015, name: "Handbags & Purses",               icon: ShoppingBag },
  { id: 152001503, parentId: 152000015, name: "Sunglasses",                      icon: Star },
  { id: 152001504, parentId: 152000015, name: "Jewellery & Earrings",            icon: Gem },
  { id: 152001505, parentId: 152000015, name: "Luxury Fragrance",                icon: Gem },
  { id: 152001506, parentId: 152000015, name: "Hats, Caps & Beanies",            icon: Shirt },

  /* Tech */
  { id: 152001601, parentId: 152000016, name: "Wireless Earbuds & Headphones",   icon: Music },
  { id: 152001602, parentId: 152000016, name: "Smart Watches & Fitness Bands",   icon: Watch },
  { id: 152001603, parentId: 152000016, name: "Power Banks & Chargers",          icon: Camera },
  { id: 152001604, parentId: 152000016, name: "Phone Accessories",               icon: Camera },
  { id: 152001605, parentId: 152000016, name: "Mini Speakers",                   icon: Music },
  { id: 152001606, parentId: 152000016, name: "Cameras & Instant Printers",      icon: Camera },

  /* Food & Drink Hampers */
  { id: 152001701, parentId: 152000017, name: "Wine & Cheese Hampers",           icon: Wine },
  { id: 152001702, parentId: 152000017, name: "Gourmet Food Baskets",            icon: ShoppingBag },
  { id: 152001703, parentId: 152000017, name: "Coffee & Tea Gift Sets",          icon: Coffee },
  { id: 152001704, parentId: 152000017, name: "Beer & Spirits Gift Packs",       icon: Wine },
  { id: 152001705, parentId: 152000017, name: "Bespoke Picnic Hampers",          icon: Gift },

  /* Personalised */
  { id: 152001801, parentId: 152000018, name: "Engraved Gifts",                  icon: Palette },
  { id: 152001802, parentId: 152000018, name: "Photo Books & Prints",            icon: Camera },
  { id: 152001803, parentId: 152000018, name: "Custom Jewellery",                icon: Gem },
  { id: 152001804, parentId: 152000018, name: "Name & Message Gifts",            icon: FileText },
  { id: 152001805, parentId: 152000018, name: "Custom Clothing & Mugs",          icon: Shirt },

  /* Music & Entertainment */
  { id: 152001901, parentId: 152000019, name: "Vinyl Records & CD Sets",         icon: Music },
  { id: 152001902, parentId: 152000019, name: "Concert & Show Tickets",          icon: Music },
  { id: 152001903, parentId: 152000019, name: "Musical Instruments (Starter)",   icon: Music },
  { id: 152001904, parentId: 152000019, name: "Streaming Subscriptions",         icon: Star },

  /* Experiences */
  { id: 152002001, parentId: 152000020, name: "Restaurant Vouchers",             icon: Coffee },
  { id: 152002002, parentId: 152000020, name: "Spa Day Vouchers",                icon: Leaf },
  { id: 152002003, parentId: 152000020, name: "Adventure & Activity Vouchers",   icon: Star },
  { id: 152002004, parentId: 152000020, name: "Travel & Hotel Gift Cards",       icon: Globe },
  { id: 152002005, parentId: 152000020, name: "Cooking & Craft Classes",         icon: Palette },

  /* Cards */
  { id: 152002101, parentId: 152000021, name: "Greeting Cards",                  icon: FileText },
  { id: 152002102, parentId: 152000021, name: "Gift Wrap & Ribbon",              icon: Ribbon },
  { id: 152002103, parentId: 152000021, name: "Gift Boxes & Bags",               icon: Gift },
  { id: 152002104, parentId: 152000021, name: "Digital E-cards",                 icon: FileText },

  /* Cultural */
  { id: 152002201, parentId: 152000022, name: "Islamic & Arabic Gifts",          icon: Globe },
  { id: 152002202, parentId: 152000022, name: "Jewish & Hanukkah Gifts",         icon: Globe },
  { id: 152002203, parentId: 152000022, name: "Hindu & Diwali Gifts",            icon: Flame },
  { id: 152002204, parentId: 152000022, name: "African Heritage Gifts",          icon: Globe },
  { id: 152002205, parentId: 152000022, name: "Christian & Easter Gifts",        icon: Sparkles },
];

export const giftsProducts: CategoryItem[] = [
  { id: 152010101, parentId: 152000102, name: "Custom Birthday Cake (6-inch)",   icon: Cake },
  { id: 152010201, parentId: 152000201, name: "Red Rose Bouquet (12 stems)",     icon: Flower2 },
  { id: 152010202, parentId: 152000203, name: "Diamond Tennis Bracelet",         icon: Gem },
  { id: 152010301, parentId: 152000301, name: "Wedding Registry Gift Voucher",   icon: Gift },
  { id: 152010401, parentId: 152000401, name: "Personalised Baby Onesie",        icon: Baby },
  { id: 152010501, parentId: 152000501, name: "Engraved Graduation Frame",       icon: Trophy },
  { id: 152010601, parentId: 152000601, name: "Branded Notebook Set",            icon: Briefcase },
  { id: 152010701, parentId: 152000701, name: "Mixed Seasonal Bouquet",          icon: Flower2 },
  { id: 152010801, parentId: 152000801, name: "Chanel N°5 Perfume 50ml",         icon: Gem },
  { id: 152010901, parentId: 152000901, name: "Belgian Chocolate Truffle Box",   icon: Candy },
  { id: 152011001, parentId: 152001001, name: "LEGO Creator Set",                icon: Gamepad2 },
  { id: 152011101, parentId: 152001101, name: "Bestseller Hardback Book",        icon: BookOpen },
  { id: 152011201, parentId: 152001201, name: "Christmas Gift Hamper",           icon: Sparkles },
  { id: 152011301, parentId: 152001301, name: "Luxury Soy Candle Set",           icon: Flame },
  { id: 152011401, parentId: 152001401, name: "Spa Pamper Gift Basket",          icon: Leaf },
  { id: 152011601, parentId: 152001601, name: "Wireless Earbuds",                icon: Music },
  { id: 152011701, parentId: 152001701, name: "Wine & Cheese Hamper",            icon: Wine },
  { id: 152011801, parentId: 152001801, name: "Engraved Name Keyring",           icon: Palette },
  { id: 152012001, parentId: 152002001, name: "Fine Dining Voucher €100",        icon: Coffee },
  { id: 152012101, parentId: 152002101, name: "Premium Gift Box with Ribbon",    icon: Gift },
];

export const giftsOccasions = [
  { id: 15200001, name: "Birthday" },
  { id: 15200002, name: "Anniversary" },
  { id: 15200003, name: "Wedding" },
  { id: 15200004, name: "Baby Shower" },
  { id: 15200005, name: "Graduation" },
  { id: 15200006, name: "Valentine's Day" },
  { id: 15200007, name: "Mother's Day" },
  { id: 15200008, name: "Father's Day" },
  { id: 15200009, name: "Christmas" },
  { id: 15200010, name: "Eid" },
  { id: 15200011, name: "Diwali" },
  { id: 15200012, name: "Easter" },
  { id: 15200013, name: "Retirement" },
  { id: 15200014, name: "New Job / Promotion" },
  { id: 15200015, name: "Housewarming" },
  { id: 15200016, name: "Get Well Soon" },
  { id: 15200017, name: "Thank You" },
  { id: 15200018, name: "Just Because" },
  { id: 15200019, name: "Corporate Event" },
];

export const giftsPriceRanges = [
  { id: 15201001, name: "Under €20" },
  { id: 15201002, name: "€20 – €50" },
  { id: 15201003, name: "€50 – €100" },
  { id: 15201004, name: "€100 – €250" },
  { id: 15201005, name: "€250 – €500" },
  { id: 15201006, name: "€500+" },
];

export const renderGiftsIcon = (
  Icon: React.ComponentType<{ size?: number; color?: string }>,
  color = "#555",
  size = 22
) => <Icon size={size} color={color} />;
